var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item'),_vm._l((_vm.breadcrumb),function(item){return _c('el-breadcrumb-item',{key:item.name},[_vm._v(" "+_vm._s(item.name)+" ")])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }